export default "__VITE_ASSET__DgjCQVMF__"